import { IDexTrade } from '@kattana-io/common';
import { ACTION_ADD_TRADE, ACTION_APPEND, ACTION_CLEAR, ACTION_REPLACE, ACTION_UPDATE_META } from '../actions/dex_trades';

export interface IDexTradesState {
  loading: boolean;
  pair: string | null;
  trades: IDexTrade[];
  meta: IMeta;
}

export interface IMeta {
  byBlock: any,
  byWallet: any
}

const defaultState = {
  loading: true,
  pair: null,
  trades: [],
  meta: { byBlock: {}, byWallet: {} },
};

const dexTrades = (state: IDexTradesState = defaultState, action: any) => {

  // limit only for add_trade because append has a limit of 500 from backend
  let trades = [action.payload]; //  https://eslint.org/docs/rules/no-case-declarations
  if (state.trades) {
    trades = trades.concat([ ...state.trades]);
  }
  trades.length > 500 && (trades.length = 500);

  switch (action.type) {
  case ACTION_CLEAR:
    return defaultState;
  case ACTION_REPLACE:
    return {
      ...state,
      ...action.payload,
    };
  case ACTION_APPEND:
    return {
      ...state,
      trades: [...action.payload, ...state.trades],
    };
  case ACTION_ADD_TRADE:
    return {
      ...state,
      trades,
    };
  case ACTION_UPDATE_META:
    return {
      ...state,
      meta: action.payload,
    };
  default:
    return state;
  }
};

export default dexTrades;
